import { render, staticRenderFns } from "./TableCellDocument.vue?vue&type=template&id=0cec72ca&"
import script from "./TableCellDocument.vue?vue&type=script&lang=ts&"
export * from "./TableCellDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports